import { createSelector } from 'reselect';
import { getWorkOrderManagement } from './getWorkOrderManagement';

export const getShiftHandoverOpen = createSelector(
  [getWorkOrderManagement],
  (workOrderManagement) => {
    return workOrderManagement.shiftHandoverOpen;
  }
);
